import { gql as n } from "@apollo/client";
const r = n`
  mutation BindFingerprint($fingerprintInput: FingerprintInput!) {
    bindFingerprint(fingerprintInput: $fingerprintInput)
  }
`;
export {
  r as default
};
//# sourceMappingURL=bindFingerprint.js.map
